export default __webpack_public_path__ + "static/media/total-input-lake.0437c998.png";